// =====================================================
// TYPES: FILES
// Description: Types pour la gestion des fichiers
// =====================================================

export type EntityType = 'contact' | 'crew';

export interface EntityFile {
  id: string;
  entity_type: EntityType;
  entity_id: string;
  name: string;
  file_path: string;
  file_size: number;
  mime_type: string;
  uploaded_by: string | null;
  created_at: string;
}

export interface UploadFileInput {
  entity_type: EntityType;
  entity_id: string;
  file: File;
  name: string;
}

// Fonction helper pour formater la taille des fichiers
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

// Fonction helper pour obtenir l'icône selon le type MIME
export function getFileIcon(mimeType: string): string {
  if (mimeType.startsWith('image/')) return '🖼️';
  if (mimeType.startsWith('video/')) return '🎥';
  if (mimeType.startsWith('audio/')) return '🎵';
  if (mimeType.includes('pdf')) return '📄';
  if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
  if (mimeType.includes('excel') || mimeType.includes('sheet')) return '📊';
  if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return '📽️';
  if (mimeType.includes('zip') || mimeType.includes('rar') || mimeType.includes('archive'))
    return '📦';
  return '📎';
}
